import {
  JOB_STATUSES,
  ACTIVE_JOBS,
  UNFINISHED_JOBS,
  PAST_JOBS,
} from '@/constants/job-statuses';

export function createJobStatus (data) {
  const statusDetails = JOB_STATUSES[data];

  return {
    ...statusDetails,
    isOpen: statusDetails.name === JOB_STATUSES.open.name,
    isInProgress: statusDetails.name === JOB_STATUSES.in_progress.name,
    isCompleted: statusDetails.name === JOB_STATUSES.completed.name,
    isExpired: statusDetails.name === JOB_STATUSES.expired.name,
    isCanceled: statusDetails.name === JOB_STATUSES.canceled.name,
    // Buckets
    isActive: ACTIVE_JOBS.statuses.some(status => statusDetails.name === status),
    isUnfinished: UNFINISHED_JOBS.statuses.some(status => statusDetails.name === status),
    isPast: PAST_JOBS.statuses.some(status => statusDetails.name === status),
  };
}
